import { useState, useEffect } from 'react';
import { api } from '../../../api/client';

export function RulePreviewBadge({ sellerId, min, max }: { sellerId: number; min: number; max: number }) {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    if (isNaN(min) || isNaN(max)) return;
    const timer = setTimeout(async () => {
      const res = await api.post<any>('/v3/rules/preview', { seller_id: sellerId, min_price_usd: min, max_price_usd: max });
      if (res.success && res.data) setCount(res.data.affected_items);
    }, 500);
    return () => clearTimeout(timer);
  }, [sellerId, min, max]);

  if (count === null) return null;
  return (
    <span className="px-2 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 rounded text-[10px] font-medium">
      {count} items afectados
    </span>
  );
}
